import { render } from "./PageButtons.component.vue?vue&type=template&id=e80f0990&scoped=true&ts=true"
import script from "./PageButtons.component.vue?vue&type=script&lang=ts"
export * from "./PageButtons.component.vue?vue&type=script&lang=ts"

import "./PageButtons.component.vue?vue&type=style&index=0&id=e80f0990&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80f0990"]])

export default __exports__